import RecordedWebinarType from 'pages/Home/RecordedWebinarType'
import VideoType from 'pages/Home/VideoType'

import { PATHS } from './routing'

export function freeTrialUrl(): string {
  return `${process.env.WWW_URI}/360/trial`
}

export function purchase360Url(): string {
  return `${process.env.WWW_URI}/order?team=true&education=false`
}

const subscriptionsUrl = `${process.env.ACCOUNT_MANAGEMENT_URI}/subscriptions`

export function addTeamMemberUrl(subscriptionId?: string): string {
  return subscriptionId ? `${subscriptionsUrl}/${subscriptionId}/invite` : process.env.ACCOUNT_MANAGEMENT_URI
}

export function teamManagementUrl(subscriptionId?: string): string {
  return subscriptionId ? `${subscriptionsUrl}/${subscriptionId}/team` : process.env.ACCOUNT_MANAGEMENT_URI
}

export function webinarDetailUrl(recordedWebinar: Pick<RecordedWebinarType, 'slug'>) {
  return `${PATHS.webinars}/${encodeURIComponent(recordedWebinar.slug)}`
}

export function videoUrl(video: Pick<VideoType, 'slug'>) {
  return `${PATHS.videos}/${encodeURIComponent(video.slug)}`
}
